var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{staticClass:"gl-bg-transparent!",attrs:{"variant":"link"}},[_c('assignee-avatar',{attrs:{"user":_vm.user,"img-size":24,"issuable-type":_vm.issuableType}}),_vm._v(" "),_c('user-name-with-status',{attrs:{"name":_vm.user.name,"availability":_vm.availability,"container-classes":"author"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }